import { useRoute, useRuntimeConfig } from '#imports'
import { ref, watch } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { isBrowser } from '@backmarket/utils/env/isBrowser'

import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

import { useRequests } from './useRequests'

const getTimeoutOptions = () => {
  if (isBrowser()) return {}

  return { timeout: 2000 }
}

function useFetchRatingDetailsSummary() {
  const route = useRoute()
  const requests = useRequests()
  const { productId } = useUrlParams()

  const {
    public: { FF_REVIEWS_ENABLE_SUMMARY_SSR },
  } = useRuntimeConfig()

  const timeoutOptions = getTimeoutOptions()

  if (!requests || !('getRatingDetailsSummary' in requests))
    return { data: ref(), error: ref(), pending: ref(false) }

  return useHttpFetch(requests.getRatingDetailsSummary, {
    ...timeoutOptions,
    pathParams: {
      uuid: route.params?.uuid ? route.params.uuid : productId,
    },
    server: !!FF_REVIEWS_ENABLE_SUMMARY_SSR,
    lazy: true,
  })
}

export function useRatingDetailsSummary() {
  const route = useRoute()
  const logger = useLogger()

  const { data, error, pending } = useFetchRatingDetailsSummary()

  watch(
    error,
    (err) => {
      if (err && err instanceof Error) {
        logger.error(`[REVIEWS][${route.name?.toString()}]`, {
          error: error.value,
          owners: ['bot-squad-content-front'],
        })
      }
    },
    { immediate: true },
  )

  return { data, pending }
}
